import * as yup from 'yup';

const idRegExp = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
const today = new Date();
today.setHours(0, 0, 0, 0)

export const adminDataSchema = yup.object().shape({
  organizationId: yup
    .string()
    .matches(idRegExp, 'Organization ID is not in the correct format.')
    .required('You have to select an organization.'),
  facilityId: yup
    .string()
    .matches(idRegExp, 'Facility ID is not in the correct format.')
    .nullable(),
  binderId: yup
    .string()
    .required('You have to select a Binder.'),
  issueTemplateId: yup
    .string()
    .matches(idRegExp, 'Issue Template ID is not in the correct format.')
    .required('You have to select an Issue Template.'),
  inspectionTemplateId: yup
    .string()
    .matches(idRegExp, 'Inspection Template ID is not in the correct format.')
    .required('You have to select an Inspection Template.'),
    inspectionStart: yup
    .date()
    .required('You have to select a date.')
    .min(today, 'Date cannot be in the past'),
    createCmTab: yup
      .boolean()
      .required(),
    tabName: yup
      .string()
      .nullable(),
});

export const binderTemplateDataSchema = yup.object().shape({
  organizationId: yup
    .string()
    .matches(idRegExp, 'Organization ID is not in the correct format.')
    .required()
});